<template>
	<div id="wrapper">
		<SidebarView :fixed_deposit="true" :operation="true" :operations-visible="true" />
		<div class="d-flex flex-column" id="content-wrapper">
			<div id="content">
				<TopbarView />
				<div class="card card-shape home-box mx-2">
					<div class="card-header">
						<div class="row align-items-center">
							<div class="col">
								<h6 class="m-0 fw-bold text-green">
									Fixed Deposit Terms
								</h6>
							</div>
							<div class="col text-end d-flex align-items-center justify-content-end">
								<create-fixed-deposit @saveFD="saveFD" :fd_scheme="fd_scheme
									"></create-fixed-deposit>
								<b-link @click="exportToExcel" class="fw-semibold ms-2 akkurate-green">
									<font-awesome-icon :icon="['fas', 'file-excel']" /></b-link>
							</div>
						</div>
					</div>
					<div class="card-body" style="
							background-color: #eaeff2;
							border-bottom: 1px solid rgb(1, 134, 115);
						">
						<div class="card card-shape home-box border border-success">
							<div class="row text-center my-2">
								<div class="col">
									<p class="mb-0 small">
										<font-awesome-icon :icon="['fas', 'circle']" class="akkurate-green rounded-circle" />
										Total Deposits<br />
										{{ institution.currency_code }}
										{{
											displayNumber(
												Number(
													totals.total_deposits
												).toFixed(2)
											)
										}}
										<!-- <span class="fw-bold">{{
                                                displayNumber(total_complete_deposits) }}</span> -->
									</p>
								</div>
								<div class="col">
									<p class="mb-0 small">
										<font-awesome-icon :icon="['fas', 'circle']" class="akkurate-danger rounded-circle" />
										Total Expected Interest <br />
										{{ institution.currency_code }}
										{{
											displayNumber(
												Number(
													totals.total_expected_interest
												).toFixed(2)
											)
										}}
										<!-- <span class="fw-bold">{{
                                                displayNumber(total_complete_withdrawals)
                                                }}</span> -->
									</p>
								</div>
								<div class="col">
									<p class="mb-0 small">
										<font-awesome-icon :icon="['fas', 'circle']" class="akkurate-grey rounded-circle" />
										Total Maturity Value <br />{{
											institution.currency_code
										}}
										{{
											displayNumber(
												Number(
													totals.total_maturity_value
												).toFixed(2)
											)
										}}
									</p>
								</div>
								<div class="col">
									<p class="mb-0 small">
										<font-awesome-icon :icon="['fas', 'circle']" class="akkurate-orange-text rounded-circle" />
										Total Interest Due<br />{{
											institution.currency_code
										}}
										{{
											displayNumber(
												Number(
													totals.total_interest_accrued
												).toFixed(2)
											)
										}}
									</p>
								</div>
							</div>
							<hr class="m-0" />
							<div class="card-body py-2 mb-3">
								<form @submit.prevent="basicSearch">
									<basic-search :filter="filter" :branches="branches" :fd_scheme="fd_scheme"></basic-search>
								</form>
							</div>
						</div>
					</div>
					<div class="card-body px-0 pt-0">
						<div class="table_text_size">
							<b-table striped bordered responsive id="fixed-deposit-table" :busy.sync="isBusy" :items="rows" :fields="columns" :tbody-tr-class="rowClass" show-empty>
								<template #table-busy>
									<div class="text-center text-danger my-2">
										<b-spinner class="align-middle"></b-spinner>
										<strong>Loading...</strong>
									</div>
								</template>
								<template #empty="scope">
									<h4 class="text-center small mt-3">
										{{ scope.emptyText }}
									</h4>
								</template>
								<template #cell(customer_full_name)="data">
									<div>
										{{ data.item.customer.first_name }}
										{{ data.item.customer.last_name }}
									</div>
								</template>
								<template #cell(principal)="data">
									<div>
										{{
											displayNumber(
												data.item?.fixed_deposit
													?.principal_amount
											)
										}}
									</div>
								</template>
								<template #cell(interest_expected)="data">
									<div>
										{{
											displayNumber(
												data.item.fixed_deposit
													?.interest_expected
											)
										}}
									</div>
								</template>
								<template #cell(maturity_value)="data">
									<span>{{
										displayNumber(
											data.item?.fixed_deposit
												?.maturity_value
										)
									}}</span>
								</template>
								<template #cell(fixed_deposit.maturity_date)="data">
									<span>{{
										formatDateAndTime(data.item.fixed_deposit?.maturity_date)
									}}</span>
								</template>
								<template #cell(fixed_deposit.expected_start_date)="data">
									<span>{{
										formatDateAndTime(data.item.fixed_deposit?.expected_start_date)
									}}</span>
								</template>
								<template #cell(duration)="data">
									<div class="akkurate-dark">
										{{
											calculateDuration(
												new Date(
													data.item.expected_start_date
												),
												new Date(
													data.item.maturity_date
												)
											)
										}}
									</div>
								</template>

								<template #cell(fixed_deposit.daily_interest)="data">
									<div>
										{{
											displayNumber(
												data.item.fixed_deposit
													?.daily_interest
											)
										}}
									</div>
								</template>

								<template #cell(fixed_deposit.interest_due)="data">
									<div>
										{{
											displayNumber(
												data.item.fixed_deposit
													?.interest_due
											)
										}}
									</div>
								</template>
								<template #cell(actions)="data">
									<!-- View Action -->
									<div class="d-flex">
										<a title="View" class="btn btn-sm akkurate-warning text-white border-0" @click="
											onFixedDeposit(
												data.item,
												'view'
											)
											">
											<span class="akkurate-small">
												<font-awesome-icon :icon="['fas', 'eye']" />
											</span>
										</a>
										<!-- delete -->
										<a title="Delete" class="btn btn-sm akkurate-red-btn text-end text-white" v-if="
											data.item?.fixed_deposit?.status?.toUpperCase() ==
											'PENDING' ||
											data.item?.fixed_deposit?.status?.toUpperCase() ==
											'REJECTED'
										" @click="deleteFD(data.item)" variant="primary">
											<span class="akkurate-small">
												<i class="fas fa-trash"></i></span>
										</a>
										<!-- redeem -->
										<reedemed v-if="
											data.item?.fixed_deposit?.status?.toUpperCase() ==
											'RUNNING' ||
											data.item?.fixed_deposit?.status?.toUpperCase() ==
											'MATURED'
										" :data="data.item" :refresh_items="loadItems" :liquid_funds="liquid_funds" :bank_currents="bank_currents
											"></reedemed>
									</div>
								</template>
							</b-table>
							<div class="d-flex justify-content-between pt-1 px-3 pb-3">
								<b-pagination class="mt-1" @change="navigatePage" v-model="currentPage" :total-rows="totalRecords" :per-page="perPage" aria-controls="loan-table"></b-pagination>

								<div class="col text-end mt-1">
									<div>
										{{ currentPage }} - {{ perPage }} of
										{{ totalRecords }}
									</div>
									<b-form-group label="Per Page" label-size="sm" class="mb-0">
										<b-form-select @change="selectPerPage" id="per-page-select" v-model="perPage" :options="per_page_options" size="sm"></b-form-select>
									</b-form-group>
								</div>
							</div>
							<!-- Modal: FD View (Unique for Each Row) -->
							<b-modal :id="'fd-modal-' + currentFDId" size="xxl" @shown="showView">
								<template #modal-title>
									<h6 class="m-0 fw-bold text-green">
										Fixed Deposit View
									</h6>
								</template>

								<!-- Fixed Deposit View Component -->
								<fixed-view :data="currentFdData" :institution="institution" :user_role="user_role" :user_pemissions="user_pemissions" :current_user_id="current_user_id" @approvedFD="approvedFD"></fixed-view>

								<template #modal-footer>
									<div class="w-100">
										<b-button @click="
											$bvModal.hide(
												'fd-modal-' + currentFDId
											)
											" type="submit" class="akkurate-gray-btn btn-size float-right">
											<font-awesome-icon class="me-2" :icon="['fas', 'close']" />Close
										</b-button>
									</div>
								</template>
							</b-modal>
						</div>
					</div>
				</div>
			</div>
			<footer></footer>
		</div>

		<!-- AI -->
		 <ChatBot />
		<!-- End AI -->
		<a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
	</div>
</template>

<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import BasicSearch from "./form/BasicSearch.vue";
// import Search from './form/Search.vue'
// import AdvanceSearch from './form/AdvanceSearch.vue';
import ApiService from "@/core/services/api.service";
import Reedemed from "./form/modal/Reedemed.vue";
import Approval from "./form/modal/Approval.vue";
import Advice from "./reports/Advice.vue";
import CreateFixedDeposit from "./form/modal/create/CreateFixedDeposit.vue";
import FixedView from "./form/modal/view/FixedView.vue";
import { decryptData } from "@/crypto";
import ExcelJS from "exceljs";
import ChatBot from "@/views/components/AI/ChatBot.vue";

export default {
	components: {
		SidebarView,
		TopbarView,
		Footer,
		BasicSearch,
		// Search,
		// AdvanceSearch,
		Reedemed,
		Approval,
		Advice,
		CreateFixedDeposit,
		FixedView,
		// DepositForm
		ChatBot,
	},
	created() {
		this.loadItems();
		this.getInsistution();
		this.getDropdown();
	},
	data() {
		return {
			form: {
				payment: "Cash",
			},
			institution: "",
			filter: {
				code: "",
				search: "",
				status: "",
				from_date: "",
				to_date: "",
				branch: "",
				trans_source: "",
				branch_option: [],
				fixed_deposit_scheme: "",
			},
			user_role: "",
			user_pemissions: "",
			current_user_id: "",
			currentFdData: "",
			branches: {},
			liquid_funds: {},
			fd_scheme: [],
			bank_currents: {},
			isBusy: true,
			currentPage: 1,
			perPage: 10,
			per_page_options: ["10", "20", "50", "100"],
			per_page_selected: "10",
			totals: {
				total_deposits: "",
				total_expected_interest: "",
				total_maturity_value: "",
				total_interest_accrued: "",
			},
			// advSearch: {},
			// action: {
			//     search_btn: "Search",
			//     disabled_search: false,
			// },
			columns: [
				{
					label: "FD #",
					key: "fixed_deposit.code",
				},
				{
					label: "Scheme",
					key: "fixed_deposit.fixed_deposit_product.name",
				},
				{
					label: "Member Name",
					key: "customer_full_name",
				},
				{
					label: "Principal",
					key: "principal",
				},
				{
					label: "Expected Interest",
					key: "interest_expected",
				},
				{
					label: "Duration",
					key: "fixed_deposit.current_duration",
				},
				{
					label: "Maturity.VAL",
					key: "maturity_value",
				},
				{
					label: "Maturity Date",
					key: "fixed_deposit.maturity_date",
				},
				{
					label: "Rate",
					key: "fixed_deposit.interest_rate",
				},
				{
					label: "Tenure",
					key: "fixed_deposit.tenor",
				},
				{
					label: "Start Date",
					key: "fixed_deposit.expected_start_date",
				},
				{
					label: "Status",
					key: "fixed_deposit.status",
				},
				{
					label: "Mandate",
					key: "fixed_deposit.fixed_deposit_mandate",
				},
				{
					label: "Daily interest",
					key: "fixed_deposit.daily_interest",
				},
				{
					label: "Interest due",
					key: "fixed_deposit.interest_due",
				},
				{
					label: "Action",
					key: "actions",
				},
			],
			rows: [],
			isLoading: false,
			totalRecords: 0,
			currentFDId: "",
			serverParams: {
				columnFilters: {},
				sort: [
					{
						field: "",
						type: "",
					},
				],
				page: 1,
				perPage: 20,
			},
		};
	},
	methods: {
		rowClass() {
			return "custom-row-height";
		},
		navigatePage(index) {
			this.isBusy = true;
			this.currentPage = index;
			this.loadItems();
		},
		selectPerPage(index) {
			this.perPage = index;
			this.loadItems();
		},
		// updateParams(newProps) {
		//     this.serverParams = Object.assign({}, this.serverParams, newProps);
		// },

		// onPageChange(params) {
		//     this.updateParams({ page: params.currentPage });
		//     this.loadItems();
		// },

		// onPerPageChange(params) {
		//     this.updateParams({ perPage: params.currentPerPage });
		//     this.loadItems();
		// },
		onSortChange(params) {
			// console.log('Column Index:', params.columnIndex);
			// console.log('Columns:', this.columns);

			// Ensure the columnIndex is valid
			if (
				params.columnIndex >= 0 &&
				params.columnIndex < this.columns.length
			) {
				this.updateParams({
					sort: [
						{
							type: params.sortType,
							field: this.columns[params.columnIndex].field,
						},
					],
				});
				this.loadItems();
			} else {
				console.error("Invalid column index:", params.columnIndex);
			}
		},

		onColumnFilter(params) {
			this.updateParams(params);
			this.loadItems();
		},
		basicSearch() {
			console.log(this.filter);
			this.loadItems();
		},

		// load items is what brings back the rows from server
		async loadItems() {
			this.isBusy = true; // Set isBusy to true when data is being loaded
			this.$Progress.start();
			this.isLoading = true;
			await ApiService.query("/investments/fixed-term-deposits", {
				params: {
					page: this.currentPage,
					per_page: this.perPage,
					branch_ids: this.filter.branch, //ie fixed deposit number
					start_date: this.filter.from_date,
					end_date: this.filter.to_date,
					status: this.filter.status, // "COMPLETED", "PENDING", "FAILED"
					filter: this.filter.search,
					branch_ids: this.filter.branch,
					fixed_deposit_scheme:
						this.filter.fixed_deposit_scheme?.id,
				},
			})
				.then((response) => {
					// console.log(response.data.data.data);
					this.rows = response.data.data.data;
					console.log(this.rows);
					this.totalRecords = response.data.data.total;
					this.totals = response.data.totals;
					this.isLoading = false;
					this.isBusy = false; // Set isBusy to false when the data is loaded
					this.$Progress.finish(); // Finish the progress bar
				})
				.catch((error) => {
					console.log(error);
					this.isLoading = false;
					this.isBusy = false; // Set isBusy to false when the data is loaded
					this.$Progress.finish(); // Finish the progress bar
				});
		},

		async getDropdown() {
			await ApiService.get(
				"/investments/fixed-term-deposits/dropdown"
			)
				.then((response) => {
					this.branches = response.data.branches;
					this.liquid_funds = response.data.liquid_funds;
					this.fd_scheme = response.data.fd_scheme;
					this.bank_currents = response.data.bank_currents;

					// this.product_options = response.data.coa_subheads;
					// console.log(response.data.coa_subheads);
				})
				.catch((error) => {
					console.log(error);
				});
		},
		// getSingleFD() {
		//     this.action.search_btn = "Processing...."
		//     this.action.disabled_search = true;
		//     ApiService.get(`/investments/fixed-term-deposits/${this.filter.code}`)
		//         .then((response) => {
		//             // console.log(response.data.data);
		//             let payment = this.form.payment;
		//             this.form = response.data.data
		//             let first_name = this.form?.customer?.first_name != null ? this.form?.customer?.first_name : "";
		//             let last_name = this.form?.customer?.last_name != null ? this.form?.customer?.last_name : "";
		//             this.form.customer_name = first_name + ' ' + last_name;
		//             this.form.payment = payment;
		//             this.action.search_btn = "Search"
		//             this.action.disabled_search = false;
		//         }).catch((error) => {
		//             this.action.search_btn = "Search"
		//             this.action.disabled_search = false;
		//             console.log(error);
		//         })
		// },
		// advanceSearch(data) {
		//     this.advSearch = data;
		//     // console.log(this.advSearch);
		//     this.loadItems();
		// },
		async getInsistution() {
			await ApiService.get("/settings/institution")
				.then((response) => {
					// console.log(response);
					this.institution = response.data.data;
				})
				.catch((error) => {
					// console.log(error);
				});
		},
		calculateDuration(startDate, endDate) {
			// Convert both dates to milliseconds
			const startMillis = startDate.getTime();
			const endMillis = endDate.getTime();

			// Calculate the difference in milliseconds
			let durationMillis = Math.abs(endMillis - startMillis);

			// Calculate the duration in days, hours, minutes, and seconds
			const millisecondsInDay = 1000 * 60 * 60 * 24;
			const days = Math.floor(durationMillis / millisecondsInDay);
			durationMillis %= millisecondsInDay;
			// const hours = Math.floor(durationMillis / (1000 * 60 * 60));
			// durationMillis %= (1000 * 60 * 60);
			// const minutes = Math.floor(durationMillis / (1000 * 60));
			// durationMillis %= (1000 * 60);
			// const seconds = Math.floor(durationMillis / 1000);

			// Return an object with the duration components
			return days;
			// return {
			//     days: days,
			//     hours: hours,
			//     minutes: minutes,
			//     seconds: seconds
			// };
		},
		approvedFD() {
			this.$bvModal.hide("fd-modal-" + this.currentFDId);
			this.loadItems();
		},
		async exportToExcel() {
			const fileUrl = "/REPORT_TEMPLATE_NEW.xlsx"; // Path to the file in the public folder
			const imageUrl = "/default_logo.png"; // Path to your image file

			// Institution details
			const institutionName = this.institution.name;
			const institutionMotto = this.institution.motto;
			const institutionAddress = this.institution.address;
			const institutionPhone = this.institution.telephone;
			const institutionEmail = this.institution.email;
			const date =
				"FROM: " +
				this.form.start_date +
				" TO: " +
				this.form.end_date;
			const terms = "TERMS:  " + this.form.terms;

			try {
				// Fetch the Excel file from the public URL
				const response = await fetch(fileUrl);
				if (!response.ok) {
					throw new Error(
						`Network response was not ok: ${response.statusText}`
					);
				}
				const arrayBuffer = await response.arrayBuffer();

				// Load the file into ExcelJS
				const wb = new ExcelJS.Workbook();
				await wb.xlsx.load(arrayBuffer);

				// Access the first sheet
				const ws = wb.getWorksheet(1); // Get the first worksheet

				// Add Image to the top of the sheet
				const imageResponse = await fetch(imageUrl);
				const imageBuffer = await imageResponse.arrayBuffer();
				const imageId = wb.addImage({
					buffer: imageBuffer,
					extension: "png", // Adjust this if you're using a different image type (e.g., jpg)
				});

				// Insert the image at the top-left corner (row 1, column 1)
				ws.addImage(imageId, {
					tl: { col: 0, row: 0 }, // Top-left corner (adjust this as needed)
					ext: { width: 300, height: 200 }, // Set the image size (adjust width/height as needed)
				});

				// Insert institution details next to the image (starting at row 1, col 5)
				const institutionDetailsStartCol = 5; // Column where text starts after image
				const institutionDetailsRow = 1; // Row for institution details

				// Add the institution name, address, and phone number
				ws.getCell(`Q${institutionDetailsRow}`).value =
					institutionName;
				ws.getCell(`Q${institutionDetailsRow}`).font = {
					bold: true,
					size: 14,
				}; // Bold and bigger font for name

				ws.getCell(`Q${institutionDetailsRow + 1}`).value =
					institutionMotto;
				ws.getCell(`Q${institutionDetailsRow + 1}`).font = {
					size: 12,
				}; // Regular font size for address

				ws.getCell(`Q${institutionDetailsRow + 2}`).value =
					institutionAddress;
				ws.getCell(`Q${institutionDetailsRow + 2}`).font = {
					size: 12,
				}; // Regular font size for phone

				ws.getCell(`Q${institutionDetailsRow + 3}`).value =
					institutionPhone;
				ws.getCell(`Q${institutionDetailsRow + 3}`).font = {
					size: 12,
				}; // Regular font size for phone

				ws.getCell(`Q${institutionDetailsRow + 4}`).value =
					institutionEmail;
				ws.getCell(`Q${institutionDetailsRow + 4}`).font = {
					size: 12,
				}; // Regular font size for phone

				ws.getCell(`Q${institutionDetailsRow + 6}`).value = date;
				ws.getCell(`Q${institutionDetailsRow + 6}`).font = {
					size: 12,
				}; // Regular font size for phone

				ws.getCell(`Q${institutionDetailsRow + 7}`).value = terms;
				ws.getCell(`Q${institutionDetailsRow + 7}`).font = {
					size: 12,
				}; // Regular font size for phone

				// Optionally adjust the column width if the text is long
				ws.getColumn("R").width = 100; // Adjust the width of column D (if necessary)

				// Define header row
				const header = [
					"code",
					"name",
					"external_code",
					"customer_full_name",
					"principal",
					"interest_expected",
					"current_duration",
					"maturity_value",
					"maturity_date",
					"interest_rate",
					"tenor",
					"expected_start_date",
					"status",
					"fixed_deposit_mandate",
					"daily_interest",
					"interest_due",
				];

				// Add header row starting from row 13 (or the next row after the image and details)
				const startingRow = institutionDetailsRow + 10; // Row 4 after institution details
				let headerRow = ws.getRow(startingRow);
				headerRow.values = header;
				headerRow.font = { bold: true };
				headerRow.commit(); // Commit the row to the worksheet

				// Add individual data rows
				let currentRow = startingRow + 1;

				let totalDrAmount = 0;
				let totalCrAmount = 0;

				// Process each item
				this.rows.forEach((item) => {
					const row = ws.getRow(currentRow);

					// Add the item values for "code", "name", "dr_amount", "cr_amount"
					row.values = [
						item.fixed_deposit.code,
						item.fixed_deposit.fixed_deposit_product.name,
						item.customer?.external_code ?? "",
						item.customer.first_name +
						" " +
						item.customer.last_name,
						item.fixed_deposit.principal,
						item.fixed_deposit.interest_expected,
						item.fixed_deposit.current_duration,
						item.maturity_value,
						item.fixed_deposit.maturity_date,
						item.fixed_deposit.interest_rate,
						item.fixed_deposit.tenor,
						item.fixed_deposit.expected_start_date,
						item.fixed_deposit.status,
						item.fixed_deposit.fixed_deposit_mandate,
						item.fixed_deposit.daily_interest,
						item.fixed_deposit.interest_due,
					];

					// Accumulate the totals
					// totalDrAmount += item.total_dr_amount || 0;
					// totalCrAmount += item.total_cr_amount || 0;

					// If there are subheads, add their data as additional rows below this one
					// if (item.subheads && Array.isArray(item.subheads)) {
					//     item.subheads.forEach(subhead => {
					//         const subheadRow = ws.getRow(currentRow + 1);
					//         subheadRow.values = [
					//             subhead.code,  // "code" of subhead
					//             subhead.name,  // "name" of subhead
					//             subhead.adjusted_dr_amount || 0,  // "dr_amount" for subhead
					//             subhead.adjusted_cr_amount || 0   // "cr_amount" for subhead
					//         ];
					//         subheadRow.commit();  // Commit the subhead row
					//         currentRow++;  // Increment row for next subhead

					//         // Accumulate subhead totals
					//         totalDrAmount += subhead.adjusted_dr_amount || 0;
					//         totalCrAmount += subhead.adjusted_cr_amount || 0;
					//     });
					// }

					// Make the main row bold
					row.font = { bold: true };

					// Commit the main row
					row.commit();
					currentRow++; // Increment row for the next item
				});

				// // Add total row at the end of the table
				// const totalRow = ws.getRow(currentRow);
				// // totalRow.getCell(2).value = "Total";  // Column B - Text 'Total'
				// // totalRow.getCell(3).value = totalDrAmount;  // Column C - Total of dr_amount
				// // totalRow.getCell(4).value = totalCrAmount;  // Column D - Total of cr_amount
				// totalRow.font = { bold: true };  // Make the total row bold
				// totalRow.commit();  // Commit the total row to the worksheet

				// Write the modified workbook to a buffer
				const buffer = await wb.xlsx.writeBuffer();
				const blob = new Blob([buffer], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				});

				// Create a download link and simulate a click to download the file
				const link = document.createElement("a");
				link.href = URL.createObjectURL(blob);
				link.download = "fixedTermDeposit.xlsx";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			} catch (err) {
				console.error(
					"Error fetching, modifying, or downloading the Excel file:",
					err.message
				);
			}
		},
		saveFD() {
			this.loadItems();
		},
		onFixedDeposit(row, type) {
			this.currentFDId = row.id; // Set the current FD ID
			this.currentFdData = row; // Set the data of the selected FD to be displayed in the modal
			// Ensure this is done immediately
			// Set the active tab based on the 'type' parameter
			// console.log(type)
			// console.log(this.currentFdData);
			// if (type === 'view') {
			//     this.term_active_menu = true;
			// }
			this.$nextTick(() => {
				this.$bvModal.show("fd-modal-" + this.currentFDId);
			});
		},
		showView() {
			// Optional: Additional logic when the modal is shown
			// console.log("FD modal is shown for ID:", this.currentFdData);
			this.user_role = decryptData(localStorage.getItem("user_role"));
			this.user_pemissions = decryptData(
				localStorage.getItem("user_pemissions")
			);
			this.current_user_id = decryptData(
				localStorage.getItem("userId")
			);
		},
		deleteFD(data) {
			swal.fire({
				title: "Delete Fixed Deposit",
				text:
					"Are you sure you want to delete fixed deposit " +
					data.fixed_deposit.code +
					" ?",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				allowOutsideClick: true,
				confirmButtonText: "YES",
				cancelButtonText: "NO",
				buttonsStyling: false, // Disable SweetAlert2 styling for buttons
				customClass: {
					confirmButton:
						"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
					cancelButton:
						"btn btn-size akkurate-danger-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
				},
			}).then((result) => {
				if (result.value) {
					this.$Progress.start();
					ApiService.delete(
						"/investments/fixed-term-deposits/" +
						data.fixed_deposit.id
					)
						.then((response) => {
							this.$Progress.finish();
							this.loadItems();
							// this.$bvToast.toast('Loan Deleted Successfully', {
							//     title: 'Success',
							//     variant: 'success',
							//     solid: true
							// })
							swal.fire({
								// title: response.statusText,
								text: response.data.message,
								icon: "success",
								allowOutsideClick: true,
								allowEscapeKey: true,
								showCancelButton: false, // Show the "Cancel" button
								confirmButtonText: "okay", // Customize the text for the "OK" button
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
							});
							this.loadItems();
						})
						.catch((error) => {
							this.$Progress.fail();

							swal.fire({
								// title: response.statusText,
								text: error.response.data.message,
								icon: "error",
								allowOutsideClick: true,
								allowEscapeKey: true,
								showCancelButton: false, // Show the "Cancel" button
								confirmButtonText: "okay", // Customize the text for the "OK" button
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
							});
						});
				}
			});
		},
	},
};
</script>
